import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import { useEffect, useState } from "react";
import LayoutModal from "../../../LayoutModal";
import Loading from "../../../Loading";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from '../../../../hooks/useLoading';
//Interface
import { ICreate } from "Interfaces/ICreate";
import { IExpense, Inputs } from "Interfaces/IExpense";
export default function Update({
  isOpenModal,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const [category, setCategory] = useState<IExpense["category_expenses"][]>([]);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const {
    isLoading: isLoadingAttribute,
    startLoading: startLoadingAttribute,
    stopLoading: stopLoadingAttribute,
  } = useLoading();

  const fetchData = async () => {
    startLoadingAttribute()
    try {
      const [response, responseCategory] = await Promise.all([
        axiosInstance.get(`expense/${selectedUrlId}`),
        axiosInstance.get('category-expense')
      ]);
      const addressData = response.data;
      setCategory(responseCategory.data);

      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoadingAttribute();
    }
  };

  useEffect(() => {
    if (isOpenModal && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModal, selectedUrlId]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = {
        ...data,
        title: data.title.toUpperCase(),
      }
      const response = await apiRequest(`expense/${selectedUrlId}`, 'PATCH', payload);
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Atualizar Saída"
        subTitle="Cadastre uma nova saída em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}
        nameSubmit="Atualizar"

        nameIconMinimize={'Atualizar Saída'}
        setMaximizeModal={fetchData}
      >
        {isLoadingAttribute ? (
          <Loading />
        ) : (
          <S.Container>
            <S.FormInput>
              <S.Label>
                Nome
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da saída"
                type="text"
                {...register("title", { required: true })}
              />
              {errors.title && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Categoria
                <span>*</span>
              </S.Label>
              <S.Select {...register("category_expense_id", { required: true })}>
                <option value="" disabled selected hidden>
                  Selecione
                </option>
                {category.map((val) => {
                  return <option value={val.id}>{val.category_expense}</option>;
                })}
              </S.Select>
              {errors.category_expense_id && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Valor
                  <span>*</span>
                </S.Label>
                <Controller
                  name="total_amount"
                  control={control}
                  rules={{ required: "Este campo é obrigatório" }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue); // Atualiza o valor de compra
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.total_amount && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Data
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe a ponta"
                  type="date"
                  {...register("date_proof", { required: true })}
                />
                {errors.date_proof && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
